import { createContext } from "react";

export const ValueOrPercentContext = createContext<"value" | "percent">(
	"value"
);
